export default __webpack_public_path__ + "static/hairpedia-video-df948426ad93443563fbea144994d36b.png";